// axios
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';

import { applyAuthToConfig, applyRefreshAuthToConfig, persistTokensFromResponse } from 'services/auth/authTransport';
import { getApiBaseUrl } from 'services/config/runtimeConfig';

interface AuthRequestConfig extends AxiosRequestConfig {
  usesRefreshToken?: boolean;
}

/**
 * Makes a request to an azure function for authentication.
 * @param {AuthRequestConfig} requestConfig Axios request config. Only the `url` is required. Set `usesRefreshToken` for endpoints that authenticate with the refresh token. For all available options see https://axios-http.com/docs/req_config.
 */
const callAzureFunctionAuth = async <T = unknown,>({
  usesRefreshToken,
  ...requestConfig
}: AuthRequestConfig): Promise<AxiosResponse<T>> => {
  const applyCredentials = usesRefreshToken ? applyRefreshAuthToConfig : applyAuthToConfig;

  const config = applyCredentials({
    ...requestConfig,
    baseURL: getApiBaseUrl()
  });

  const response = await axios<T>(config);

  await persistTokensFromResponse(response);

  return response;
};

export default callAzureFunctionAuth;
